
export default function (Component) {
  Component.options.__source = "src/views/TongJiFenXi/AcFeeDetailsTable/AcFeeDetailsTable.vue"
}
